import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute("/events/$id/slots")({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "bookable_slots",
                to: APP_ROUTES_TO.EVENT_SLOTS,
            },
            title: "bookable_slots",
        },
    },
});

function RouteComponent() {
    return <Outlet />;
}
